import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TransferTable from '../TransferTable';
import * as actions from '../../redux/actions';
import { getAccountTransfers, getAccountTransfersCount } from '../../redux/reducers';
import { removeEmpty } from '../../utils';

class AccountTransfers extends Component {
	state = {
		offset: 0,
		limit: 5,
		page: 1,
		sort: 'consensusTime',
		order: 'desc'
	};

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.accountId !== prevProps.accountId || this.props.filter !== prevProps.filter) {
			this.setState(
				{
					offset: 0,
					page: 1
				},
				() => this.fetchData()
			);
		}
	}

	loadData = (viewParams) => {
		const params = { ...this.state, ...viewParams };
		this.setState({ ...params }, () => this.fetchData());
	};

	fetchData = () => {
		const { filter, accountId, fetchAccountTransfers } = this.props;
		const params = { q: filter, ...this.state };

		const queryParams = removeEmpty(params);

		const esc = encodeURIComponent;
		const query = Object.keys(queryParams).map((p) => esc(p) + '=' + esc(queryParams[p])).join('&');
		fetchAccountTransfers(accountId, query);
	};

	showTransactionDetails = (transfer) => {
		this.props.history.push(`/transactions/${transfer.transactionID}`);
	};

	render() {
		const { transfers, totalCount } = this.props;
		return (
			<TransferTable
				transfers={transfers}
				limit={this.state.limit}
				offset={this.state.offset}
				sort={this.state.sort}
				order={this.state.order}
				totalCount={totalCount}
				loadData={this.loadData}
				showDetails={this.showTransactionDetails}
			/>
		);
	}
}

const mapStateToProps = (state, { match: { params: { accountId } } }) => ({
	accountId,
	transfers: getAccountTransfers(state, accountId),
	totalCount: getAccountTransfersCount(state, accountId)
});

AccountTransfers = withRouter(connect(mapStateToProps, actions)(AccountTransfers));

export default AccountTransfers;
